import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiUrlService } from '../shared-services/api-url.service';

@Injectable({
  providedIn: 'root'
})
export class CityServicesService {

  constructor(private base_url:ApiUrlService, private http:HttpClient) { 
    
    console.log( 'BASE_URL',this.base_url.BASE_CITY);
  }
  
  createNewCity(req: any): Observable<any> {
    const url = `${this.base_url.BASE_CITY}/create`;
    return this.http.post(url, req);
  }
  getCityWithPagination(paginationData:any, stateId: any = ''): Observable<any> {
    const url = `${this.base_url.BASE_CITY}/get_with_paginate?limit=${paginationData.limit}&currentPage=${paginationData.currentPage}${stateId === '' ? '' : `&stateId=${stateId}`}`;
    return this.http.get(url);
  }
  getACity(id:any): Observable<any> {
    const url = `${this.base_url.BASE_CITY}/${id}`;
    return this.http.get(url);
  }
  UpdateACity(req: any): Observable<any> {
    const url = `${this.base_url.BASE_CITY}/update/${req?.id}`;
    return this.http.put(url,req);
  }
  deleteCity(CityReq: string): Observable<any> {
    const url = `${this.base_url.BASE_CITY}/delete`;
    return this.http.post(url,CityReq);
  }
}
